"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILTER_TYPES = exports.UserRole = exports.WIDGET_GROUPING_TYPES = exports.NAV_MENU_HIERARCHY_TYPES = exports.LAYOUT_SOURCE = exports.NAV_MENU_TYPES = exports.TARGET_OPERATORS = exports.COMPONENT_TYPES = void 0;
var COMPONENT_TYPES;
(function (COMPONENT_TYPES) {
    COMPONENT_TYPES[COMPONENT_TYPES["TIME_GRAPH"] = 0] = "TIME_GRAPH";
    COMPONENT_TYPES[COMPONENT_TYPES["METRICS"] = 1] = "METRICS";
    COMPONENT_TYPES[COMPONENT_TYPES["BIG_NUMBER"] = 2] = "BIG_NUMBER";
    COMPONENT_TYPES[COMPONENT_TYPES["TIME_LINE"] = 3] = "TIME_LINE";
    COMPONENT_TYPES[COMPONENT_TYPES["PIE"] = 4] = "PIE";
    COMPONENT_TYPES[COMPONENT_TYPES["STACKED_SEGMENT_BAR"] = 5] = "STACKED_SEGMENT_BAR";
    COMPONENT_TYPES[COMPONENT_TYPES["UNSTACKED_SEGMENT_BAR"] = 6] = "UNSTACKED_SEGMENT_BAR";
    COMPONENT_TYPES[COMPONENT_TYPES["NON_TIME_BASED_STACKED_SEGMENT_BAR"] = 7] = "NON_TIME_BASED_STACKED_SEGMENT_BAR";
    COMPONENT_TYPES[COMPONENT_TYPES["MULTIPLE_QUERIES"] = 8] = "MULTIPLE_QUERIES";
})(COMPONENT_TYPES || (exports.COMPONENT_TYPES = COMPONENT_TYPES = {}));
var TARGET_OPERATORS;
(function (TARGET_OPERATORS) {
    TARGET_OPERATORS[TARGET_OPERATORS["BIGGER"] = 0] = "BIGGER";
    TARGET_OPERATORS[TARGET_OPERATORS["SMALLER"] = 1] = "SMALLER";
})(TARGET_OPERATORS || (exports.TARGET_OPERATORS = TARGET_OPERATORS = {}));
var NAV_MENU_TYPES;
(function (NAV_MENU_TYPES) {
    NAV_MENU_TYPES[NAV_MENU_TYPES["MERCHANTS_TEAMS"] = 0] = "MERCHANTS_TEAMS";
    NAV_MENU_TYPES[NAV_MENU_TYPES["TEAMS"] = 1] = "TEAMS";
})(NAV_MENU_TYPES || (exports.NAV_MENU_TYPES = NAV_MENU_TYPES = {}));
var LAYOUT_SOURCE;
(function (LAYOUT_SOURCE) {
    LAYOUT_SOURCE[LAYOUT_SOURCE["INSIGHT_APP"] = 0] = "INSIGHT_APP";
    LAYOUT_SOURCE[LAYOUT_SOURCE["BI_DASHBOARD"] = 1] = "BI_DASHBOARD";
})(LAYOUT_SOURCE || (exports.LAYOUT_SOURCE = LAYOUT_SOURCE = {}));
var NAV_MENU_HIERARCHY_TYPES;
(function (NAV_MENU_HIERARCHY_TYPES) {
    NAV_MENU_HIERARCHY_TYPES[NAV_MENU_HIERARCHY_TYPES["GLOBAL"] = 0] = "GLOBAL";
    NAV_MENU_HIERARCHY_TYPES[NAV_MENU_HIERARCHY_TYPES["MERCHANT"] = 1] = "MERCHANT";
    NAV_MENU_HIERARCHY_TYPES[NAV_MENU_HIERARCHY_TYPES["TEAM"] = 2] = "TEAM";
})(NAV_MENU_HIERARCHY_TYPES || (exports.NAV_MENU_HIERARCHY_TYPES = NAV_MENU_HIERARCHY_TYPES = {}));
var WIDGET_GROUPING_TYPES;
(function (WIDGET_GROUPING_TYPES) {
    WIDGET_GROUPING_TYPES["GROUP_BY_ORIGIN"] = "GROUP_BY_ORIGIN";
    WIDGET_GROUPING_TYPES["GROUP_BY_FLEET"] = "GROUP_BY_FLEET";
    WIDGET_GROUPING_TYPES["GROUP_BY_MERCHANT"] = "GROUP_BY_MERCHANT";
    WIDGET_GROUPING_TYPES["GROUP_BY_HOUR_OF_DAY"] = "GROUP_BY_HOUR_OF_DAY";
    WIDGET_GROUPING_TYPES["GROUP_BY_DAY_OF_WEEK"] = "GROUP_BY_DAY_OF_WEEK";
    WIDGET_GROUPING_TYPES["GROUP_BY_TEAM"] = "GROUP_BY_TEAM";
    WIDGET_GROUPING_TYPES["GROUP_BY_WP1_ARRIVAL"] = "GROUP_BY_WP1_ARRIVAL";
    WIDGET_GROUPING_TYPES["GROUP_BY_WP2_ARRIVAL"] = "GROUP_BY_WP2_ARRIVAL";
    WIDGET_GROUPING_TYPES["GROUP_BY_CUSTOMER_WP"] = "GROUP_BY_CUSTOMER_WP";
    WIDGET_GROUPING_TYPES["GROUP_BY_FLEET_WITH_INTERNAL_FLEETS"] = "GROUP_BY_FLEET_WITH_INTERNAL_FLEETS";
    WIDGET_GROUPING_TYPES["GROUP_BY_RATING"] = "GROUP_BY_RATING";
    WIDGET_GROUPING_TYPES["GROUP_BY_DRIVER"] = "GROUP_BY_DRIVER";
})(WIDGET_GROUPING_TYPES || (exports.WIDGET_GROUPING_TYPES = WIDGET_GROUPING_TYPES = {}));
var UserRole;
(function (UserRole) {
    UserRole[UserRole["Partner"] = 0] = "Partner";
    UserRole[UserRole["Admin"] = 1] = "Admin";
    UserRole[UserRole["Dispatcher"] = 2] = "Dispatcher";
})(UserRole || (exports.UserRole = UserRole = {}));
var FILTER_TYPES;
(function (FILTER_TYPES) {
    FILTER_TYPES["TIME_RANGE"] = "TIME_RANGE";
    FILTER_TYPES["COMPARE_RANGE"] = "COMPARE_RANGE";
    FILTER_TYPES["FLEETS"] = "FLEETS";
})(FILTER_TYPES || (exports.FILTER_TYPES = FILTER_TYPES = {}));
//# sourceMappingURL=reports.js.map